import script from "./Country.vue?vue&type=script&setup=true&lang=js"
export * from "./Country.vue?vue&type=script&setup=true&lang=js"

import "./Country.vue?vue&type=style&index=0&id=3ab7efe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab7efe4"]])

export default __exports__